import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Ban } from 'lucide-react';

export default function DeactivateUserModal({
  open,
  onOpenChange,
  user,
  reason,
  onReasonChange,
  onConfirm,
  isLoading
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <Ban className="w-5 h-5" />
            Deactivate User Account
          </DialogTitle>
          <DialogDescription>
            Provide a reason for deactivating {user?.name || 'this user'}'s account. This reason will be shown to the user.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div>
            <Label className="text-slate-700">Reason for Deactivation *</Label>
            <textarea
              value={reason}
              onChange={(e) => onReasonChange(e.target.value)}
              placeholder="e.g., Violation of terms of service, fraudulent activity, multiple complaints, etc."
              className="w-full mt-1.5 px-3 py-2 rounded-xl border border-stone-300 text-sm resize-none h-24 focus:outline-none focus:ring-2 focus:ring-red-500"
              data-testid="deactivation-reason"
            />
            <p className="text-xs text-slate-500 mt-1">
              This message will be displayed to the user when they try to access their account.
            </p>
          </div>

          <div className="p-3 bg-amber-50 border border-amber-200 rounded-xl">
            <p className="text-sm text-amber-800">
              <strong>Warning:</strong> The user will see a popup with this reason and will only be able to submit a support ticket to appeal.
            </p>
          </div>

          <div className="flex gap-2">
            <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button
              className="flex-1 bg-red-600 hover:bg-red-700 text-white"
              onClick={onConfirm}
              disabled={isLoading || !reason.trim()}
              data-testid="confirm-deactivation-btn"
            >
              Deactivate Account
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
